import { jsx as l } from "react/jsx-runtime";
const t = "w-full h-full flex items-center flex-col gap-5", o = ({ children: e }) => /* @__PURE__ */ l("main", { role: "main", className: t, children: e });
export {
  t as LAYOUT_BASE_CLASSNAME,
  o as default
};
